import Styles from './styles.module.css';
import SectionTitle from '../../home/_ui/sectionTitle';
import {
  IoScanOutline, IoFolderOpenOutline, IoArrowForward,
} from 'react-icons/io5';

const CARDS = [
  {
    no: '01',
    icon: <IoScanOutline />,
    title: 'スキャン',
    desc: '郵送で届いた紙の求人票を、複合機で一枚ずつ読み込み、PDF化する。',
    items: ['封筒を開けて中身を確認', '複合機まで持って行って読み込み', '向き・傾き・抜けのチェック', 'PDFとして保存'],
  },
  {
    no: '02',
    icon: <IoFolderOpenOutline />,
    title: 'ファイリング',
    desc: 'スキャンした求人票を、年度・企業ごとに名前を付けて整理する。',
    items: ['ファイル名を「年度_企業名」に変更', 'Google Drive・共有フォルダへ保存', '紙は紙でファイルに綴じて保管', '新しい求人が来るたびに追加・差し替え'],
  },
];

const Tasks = () => {
  return (
    <section id="tasks" className={Styles.tasks}>
      <SectionTitle
        pattern="B"
        title={<>求人票管理、<br className={Styles.brsp} />こんな作業が発生していませんか？</>}
        lead="毎年、多数のサロン・企業から求人票が届きます。届き方は、郵送された紙・PDF・メール添付・各社独自フォーマットとバラバラ。受け取ったあと、学校側では大きく2つの作業が繰り返されています。"
      />

      <div className={Styles.grid}>
        {CARDS.map((c) => (
          <div key={c.no} className={Styles.card}>
            <div className={Styles.cardHead}>
              <span className={Styles.cardIcon}>{c.icon}</span>
              <span className={Styles.cardNo}>{c.no}</span>
            </div>
            <h3>{c.title}</h3>
            <p className={Styles.cardDesc}>{c.desc}</p>
            <ul className={Styles.cardList}>
              {c.items.map((it) => (
                <li key={it}><IoArrowForward />{it}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <p className={Styles.take}>
        求人票そのものではなく、<br className={Styles.brsp} />
        <strong>求人票を管理するための作業</strong>に時間がかかっている。
      </p>
    </section>
  );
};

export default Tasks;
